import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../utils/context/UserContext";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
  message,
} from "antd";

import BankDefaultType from "../../utils/types/BankDefaultType";
import { getOutletExpenseCategories } from "../../utils/api/OutletAPI";

import { addBank,updateBank,deleteBank,getBankList } from "../../utils/api/BankApi";
import { IoIosRefresh } from "react-icons/io";
import { AiOutlinePlus } from "react-icons/ai";
import {
  ERROR_NOTIFICATION_TYPE,
  SUCCESS_NOTIFICATION_TYPE,
  getAPIResponseMessage,
} from "../../utils/api/_ConstantsAPI";
import { GlobalContext } from "../../App";
import { getBankTable } from "../../utils/tableData/Maintenance/BankTable";
import { getBankFields } from "../../utils/data/BankFields";
import { FormInput } from "../../components";
import Search from "antd/es/input/Search";

export default function BankMaintenance() {
  const { authToken, openNotification } = useContext(GlobalContext);
  const { profile, formItemLayout } = useContext(UserContext);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentBankState, setBankState] =
    useState(BankDefaultType);
  const [tableHeaderFilter, setTableHeaderFilter] = useState("");
  const [tableFilter, setTableFilter] = useState("");

  const [localBankList, setBankList] = useState([]);



  let tableContents = localBankList
    .filter((data) => {
      if (tableHeaderFilter === '') {
        return data;
      }
      return data[tableHeaderFilter]
        .toString()
        .toLowerCase()
        .includes(tableFilter.toLowerCase());
    })
    .map((data, index) => ({
      ...data,
      key: index,
    }));

  const getParseBankData = () => {
    const parseData = {
      bank_id: currentBankState.bank_id,
      bank_desc: currentBankState.bank_desc,
      updatedBy: profile.id,
      
    };
    return parseData;
  };

  const fetchBankList = async () => {
    setIsLoading(true);
    resetData();
    const res = await getBankList();
    console.log(res.bank_list);
    if (res.isSuccess) {
      setBankList(res.bank_list);
    } else {
      openNotification(
        ERROR_NOTIFICATION_TYPE,
        "Expense Ctegory",
        getAPIResponseMessage(res.categoryList)
      );
    }
    setIsLoading(false);
  };


  const handleAction = async (bank_id, action) => {
    setIsLoading(true);
    if (action === "edit") {
      const bankList = localBankList.find(
        (bank) => bank.bank_id === bank_id
      );
      setBankState({ ...bankList });
      form.setFieldsValue(bankList);
      setIsModalOpen(true);
    } else if (action === "delete") {
      const res = await deleteBank({
        bank_id: bank_id,
      });
      if (res.isSuccess) {
        fetchBankList();
        openNotification(
          SUCCESS_NOTIFICATION_TYPE,
          "Bank List",
          "Bank successfully deleted."
        );
      } else {
        openNotification(
          ERROR_NOTIFICATION_TYPE,
          "Bank List",
          "There was a problem deleting the Bank."
        );
      }
    }
    setIsLoading(false);
  };

  const handleModalSave = async () => {
    setIsLoading(true);
    try {
      await form.validateFields();
      if (currentBankState.bank_id === "") {
        // New product flow
        const res = await addBank(getParseBankData());
        if (res.isSuccess) {
          setIsModalOpen(false);
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            "Bank List",
            "Bank successfully added."
          );
          fetchBankList();
        } else {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            "Bank List",
            getAPIResponseMessage(res.message)
          );
        }
      } else {
        // Edit product flow
        const res = await updateBank(getParseBankData());
        console.log(res);
        if (res.isSuccess) {
          setIsModalOpen(false);
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            "Bank List",
            "Bank successfully updated."
          );
          fetchBankList();
        } else {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            "Bank List",
            "There was a problem updating the Bank."
          );
        }
      }
    } catch (error) {
      // No action needed.
    }
    setIsLoading(false);
  };



  
  const resetData = () => {
    setTableHeaderFilter("");
    setTableFilter("");
    setBankState(BankDefaultType);
    form.setFieldsValue(BankDefaultType);
  };

  useEffect(() => {
    if (localBankList.length === 0) {
      fetchBankList();
    }
  }, []);

  useEffect(() => {
    const fetchDataInterval = setInterval(() => {
      fetchBankList();
    }, 1800000);

    return () => {
      clearInterval(fetchDataInterval);
    };
  }, []);

  return (
    <Content>
      <Row align={"middle"} className="mb-4">
        <Col xs={24} md={12}>
          <Typography.Title level={3}>
            Bank Maintenance
          </Typography.Title>
        </Col>
        <Col xs={24} md={12} className="text-end">
          <Button
            type="primary"
            size="large"
            icon={<IoIosRefresh size={24} />}
            loading={isLoading}
            onClick={() => fetchBankList()}
          />
          <Button
            type="primary"
            size="large"
            icon={<AiOutlinePlus size={24} />}
            loading={isLoading}
            className="ms-3"
            onClick={async () => {
              resetData();
              setIsModalOpen(true);
            }}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Space.Compact>
          <Select
            style={{ minWidth: "10vw" }}
            placeholder="Filters"
            value={tableHeaderFilter}
            onChange={(e) => {
              setTableHeaderFilter(e);
            }}
            disabled={isLoading}
            options={getBankTable(null)
              .filter((header) => header.key !== "actions")
              .map((option) => ({
                label: option.title,
                value: option.key,
              }))}
          />
          <Search
            placeholder="Search for bank"
            disabled={isLoading || tableHeaderFilter === ""}
            value={tableFilter}
            onSearch={(value) => {
              setTableFilter(value);
            }}
            onChange={(e) => {
              const searchValue = e.target.value;
              setTableFilter(searchValue);
            }}
            allowClear={true}
          />
        </Space.Compact>
      </Row>
      <Table
        columns={getBankTable(handleAction)}
        dataSource={tableContents}
        size="small"
        bordered="true"
        scroll={{ x: true }}
        loading={isLoading}
      />
      <Modal
        title="Bank Entry"
        centered
        closable={false}
        maskClosable={false}
        open={isModalOpen}
        onOk={handleModalSave}
        okText={"Save"}
        confirmLoading={isLoading}
        onCancel={() => setIsModalOpen(false)}
      >
        <Form
          form={form}
          name="expense_category_form"
          {...formItemLayout}
          initialValues={currentBankState}
        >
          {getBankFields(
            isLoading,
            currentBankState,
            setBankState
          ).map((data, index) => (
            <FormInput
              key={index}
              type={data.type}
              name={data.name}
              placeholder={data.placeholder}
              label={data.label}
              autoFocus={data.autofocus}
              value={data.value}
              onChange={data.setValue}
              required={data.required}
              disabled={data.disabled}
              dropdownOptions={data.dropdownOptions}
            />
          ))}
        </Form>
      </Modal>
    </Content>
  );
}
